/* istanbul ignore file */
import { EnumField } from 'framework/ui/field';
import { CLOSED_REASON_LIST } from 'domain/sales/opportunity/opportunityService';

const ClosedReasonField = (props: any) => {
  return <EnumField {...props} options={CLOSED_REASON_LIST} />;
};

export default ClosedReasonField;
